/**
 * Every `--text-*` entry in `src/styles/theme/variables.css` generates a font-size utility, but
 * tailwind-merge only recognises the stock sizes (`text-sm`, `text-lg`, …). It files any other
 * `text-<name>` under text colour, so `mergeTwClasses('text-body-m', 'text-primary')` looks like two colours and
 * silently drops the first — the type scale disappears with no error and no failing test.
 *
 * Listing the tokens restores the split: sizes merge against sizes, colours against colours.
 * `merge-tw-classes.test.ts` reads the stylesheet and fails if this list drifts from it.
 */
export const FONT_SIZE_TOKENS = [
  'action-button-m',
  'action-button-s',
  'action-tag-bold',
  'actions-s',
  'body-bold-xl',
  'body-l',
  'body-m',
  'body-s',
  'body-xl',
  'body-xs',
  'date-2xl',
  'date-l',
  'date-m',
  'date-s',
  'date-xl',
  'event-card-overtitle-m',
  'event-card-overtitle-s',
  'event-card-title-m',
  'event-card-title-s',
  'headline-display',
  'headline-l',
  'headline-m',
  'headline-s',
  'headline-tiny',
  'headline-xl',
  'headline-xs',
  'link-bold-l',
  'link-bold-m',
  'link-bold-s',
  'link-bold-xs',
  'link-regular-l',
  'link-regular-m',
  'link-regular-s',
  'link-regular-xs',
  'subtitle',
  'subtitle-l',
  'subtitle-m',
  'subtitle-s',
  'subtitle-xs',
  'tiny',
  'title',
];
